import { useTranslation } from 'react-i18next'

import { Heading, Subtitle } from '../../../components/typography'
import FullWidthPage from '../../../components/layout/FullWidthPage'
import { PageContent } from '../../../components/Container'
import { useCurrentMove } from '../../../modules/moves'
import MoveCalendly from './MoveCalendly'
import { useAppConfig } from '../../../modules/appConfig'

const MoveNoQuotesPage: React.FC = () => {
  const { t } = useTranslation()
  const move = useCurrentMove()
  const { data: appConfig } = useAppConfig()
  const calendlyForLongDistance = appConfig?.calendlyForLongDistance ?? false

  return (
    <FullWidthPage>
      <PageContent>

        <div className="pt-4 text-center">

          { calendlyForLongDistance
            ? (
              <>
                <Heading variant="h1">
                  { t('pages.move.noQuotes.title') }
                </Heading>
                <Subtitle className="lg:text-center">
                  { t('pages.move.noQuotes.subtitle') }
                </Subtitle>

                <MoveCalendly move={move} />
              </>
              )
            : (
              <>
                <Heading variant="h1">
                  { t('pages.move.noQuotes.calendlyDisabled.title', {
                    firstName: move.user.firstName,
                  }) }
                </Heading>
                <Subtitle className="my-12 lg:text-center">
                  { t('pages.move.noQuotes.calendlyDisabled.line1') }
                  <br />
                  { t('pages.move.noQuotes.calendlyDisabled.line2') }
                  <br />
                  { t('pages.move.noQuotes.calendlyDisabled.line3') }
                </Subtitle>
              </>
              ) }

        </div>

      </PageContent>
    </FullWidthPage>
  )
}

export default MoveNoQuotesPage
